export default class effectManager {
    constructor(){

    }
    content($target,type){

        if(type==="set"){

            //let _clone = "<i class='js__tsc-cover'></i>";
            let _clone = document.createElement('i');

            $target.appendChild(_clone);
            TweenMax.set($target.find('.js__tsc-cover'),{
                x:'-50%'
            });

        }else{

            TweenMax.to($target,2.2, {
                delay:.8,
                x:'100%',
                ease: Power2.easeOut,
            });

        }

    }
    fade($target,type){

        if(type==="set"){
            TweenMax.set($target,{
                opacity:0,
                y:10,
            });
        }else{
            TweenMax.to($target,2, {
                delay:0.8,
                y:0,
                opacity:1,
                ease: Expo.easeOut,
            });
        }

    }
    show($target,type){

        if(type==="set"){
            TweenMax.set($target,{
                y:'40px',
                opacity:0,
                rotationX:30,
                force3D:true,
            });
        }else{
            TweenMax.staggerTo($target,2.4, {
                delay:3.0,
                y:'0px',
                opacity:1,
                rotationX:0,
                force3D:true,
                ease: Expo.easeOut,
            },0.2);
        }

    }
    scale($target,type){

        let _setZ = ($('html.safari')[0] || $('html.ios')[0]) ?0:15;

        if(type==="set"){

            TweenMax.set($target,{
                x: -5,
                y: 0,
                z: _setZ,
                opacity:0
            });

        }else{

            $target.css({'opacity':''});
            TweenMax.to($target,1, {
                delay:0.5,
                x: 0,
                y: 0,
                z: 0,
                ease: Expo.easeOut
            });
            TweenMax.from($target,1, {
                delay:0.5,
                opacity:0,
                ease: Expo.easeOut
            });

        }

    }

    splitText($target,type){

        if($target.length == 0){
          return;
        }

        if(type === "set"){
            let text = new SplitText($target, {type:"words,chars"}),
                chars = text.chars;
            TweenMax.set(chars,{ opacity:0, x:20});
            // TweenMax.set(chars,{ opacity:0, x:100,rotationX:-20, rotationY:15});
        }else if(type === "out"){
            TweenMax.staggerTo($target, 0.6,
                {
                    opacity:0,x:150,
                    // filter:"blur(0px)",
                    ease: "Power2.easeIn",
                },
                0.01
            );
        }else{
            TweenMax.staggerTo($target, 2.4,
                {
                    // opacity:1,x:0,
                    x:0,
                    y:0,
                    z:0,
                    opacity:1,
                    scale:1,
                    ease: Expo.easeOut,
                },
                0.1
            );
        }
    }

    box($target,type){

        if(type==="set"){

            TweenMax.set($target,{
                x : 110 + "%",
                scale : 1.1,
                opacity:0
            });

        }else if(type==="out"){
            TweenMax.staggerTo($target,1.1, {
                x : -110 + "%",
                scale : 1.1,
                opacity:0,
                ease: Power2.easeIn,
            },0.05);
        }else{

            TweenMax.staggerTo($target,1.1, {
                x : 0 + "%",
                scale : 1,
                opacity:1,
                ease: Power2.easeOut,
                delay : 0.7,
                // ease: Back.easeOut.config(1),
            },0.1);

        }

    }

    sectionTitle($target,type){

        if($target.length == 0){
            return;
        }

        let _title = $target.find('.js__tsc-section-title-title');
        let _text = $target.find('.js__tsc-section-title-text');
        let _line = $target.find('.js__tsc-section-title-line');

        if(type === "set"){

            let _splittext = new SplitText(_title, {type:"words,chars"}),
                chars = _splittext.chars;
            TweenMax.set(chars,{
                x: 200,
                y: -50,
                opacity:0
            });
            TweenMax.set(_text,{ opacity:0});
            TweenMax.set(_line,{ opacity:0, x:'30px'});

        }else if(type==="out"){
            TweenMax.staggerTo($target.find('.js__tsc-section-title-title').children().children(),0.8, {
                x: 100,
                y: -50,
                opacity:0,
                ease: Power2.easeOut,
            },0.05);
            TweenMax.to($target.find('.js__tsc-section-title-text'),0.8, {
                opacity:0,
                ease: Power2.easeOut,
            });
            TweenMax.to($target.find('.js__tsc-section-title-line'),0.8, {
                x: 30,
                opacity:0,
                ease: Power2.easeOut,
            });
        }else{

            $target.parents('.js__tsc').addClass('is-show');

            TweenMax.staggerFromTo(_title.children().children(),1.4, {
                x: 50,
                y: -25,
                opacity:0,
            },{
                opacity:1,
                x: 0,
                y: 0,
                ease: Expo.easeOut
            },0.05);
            TweenMax.to(_text,2, {
                delay:1.2,
                opacity: 1,
                ease: Expo.easeOut
            });
            TweenMax.to(_line,.4, {
                delay:.5,
                x: '0px',
                opacity: 1,
                ease: Expo.easeOut
            });
            TweenMax.from(_line,0.8, {
                delay: .6,
                width: '150px',
                ease: Power2.easeOut
            });
        }
    }

    Title($target,type){

        if($target.length == 0){
            return;
        }

        let _title = $target.find('.js__tsc-title-title');
        let _text = $target.find('.js__tsc-title-text');
        let _line = $target.find('.js__tsc-title-line');

        if(type === "set"){

            let _splittext = new SplitText(_title, {type:"words,chars"}),
                chars = _splittext.chars;
            TweenMax.set(chars,{
                y: 50,
                color: '#2bf3d9',
                opacity:0
            });
            TweenMax.set(_text,{ opacity:0});
            TweenMax.set(_line,{
                backgroundColor: '#2f3440',
                y:50,
                opacity:0
            });

        }else if(type==="out"){
            TweenMax.staggerTo($target.find('.js__tsc-title-title').children().children(),0.8, {
                y: -30,
                color: '#2bf3d9',
                opacity:0,
                ease: Power2.easeOut,
            },0.03);
            TweenMax.to($target.find('.js__tsc-title-text'),0.8, {
                opacity:0,
                ease: Power2.easeOut,
            });
            TweenMax.to($target.find('.js__tsc-title-line'),0.8, {
                backgroundColor: '#2f3440',
                y: -30,
                opacity:0,
                ease: Power2.easeOut,
            });
        }else{

            $target.parents('.js__tsc').addClass('is-show');

            TweenMax.to(_line,1.8, {
                opacity: 1,
                y:0,
                ease: Power4.easeOut
            });
            TweenMax.staggerFromTo(_title.children().children(),1.8, {
                y: 10,
                color: '#2bf3d9',
                opacity:0,
            },{
                delay:.15,
                y: 0,
                opacity:1,
                ease: Expo.easeOut,
                onStart:function(){
                    TweenMax.to(_line,1.2, {
                        delay:0.6,
                        backgroundColor: '#2bf3d9',
                        ease: Expo.easeOut
                    });
                }
            },0.05);
            TweenMax.staggerTo(_title.children().children(),2.1, {
                delay:.3,
                color: '#2f3440',
            },0.06);

            TweenMax.to(_text,2, {
                delay:1,
                opacity: 1,
                ease: Expo.easeOut
            });
        }
    }

    lineText($target,type){

        if($target.length == 0){
            return;
        }

        let _firstText = $target.children('.text-inner').eq(0);
        let _secondText = $target.children('.text-inner').eq(1);
        let _thirdText = $target.children('.text-inner').eq(2);

        if(type === "set"){

            TweenMax.set($target,{
                y:10,
                opacity:0
            });

        }else if(type === "out"){

            TweenMax.to($target,1, {
                y:10,
                opacity:0,
                ease: Power2.easeOut
            });

        }else{

            TweenMax.to($target,3, {
                delay:1,
                y:0,
                opacity:1,
                ease: Power2.easeOut
            });

        }

    }

    depth($target,type,hideTarget){

        let _this = this;
        let _length = $target.length;
        let _showID = $target.parents('.p-kv__inner').attr('id');

        if(type === "set"){

            $target.removeAttr('style');

            let _setX = (_showID === 'intro') ?10:1;

            if(_showID !== 'intro'){
                _this.show($('#' + _showID).find('.p-kv__text'),'set');
            }

            TweenMax.set($target.parents('.p-kv__copy').children('.number').children(), {
                x: 100,
                z: -1000,
                opacity:0,
            });
            TweenMax.set($target, {
                x:  _this.center.x +  _this.offsetX / _setX,
                y: -(_this.center.y),
                z: -2000,
                rotationX: 170,
                force3D: true,
                opacity: 0
            });

        }
        else if(type === "out") {

            let _setX1;
            if(hideTarget === 'intro') {
                _setX1 = _this.center.x + _this.offsetX / 10
            }else if(hideTarget === 'ch2'){
                _setX1 = -(_this.center.x + _this.offsetX / 0.6);
            }else{
                _setX1 = _this.center.x + _this.offsetX / 0.6;
            }
            let _setX2;
            if(hideTarget === 'intro') {
                _setX2 = '';
            }else if(hideTarget === 'ch2'){
                _setX2 = _this.center.x + _this.offsetX / 5.5;
            }else{
                _setX2 = _this.center.x + _this.offsetX / 10.5
            }
            let _setX3 = (hideTarget === 'intro') ?-(_this.center.x + _this.offsetX / 12):_this.center.x + _this.offsetX / 1.2;
            let _setY = (hideTarget === 'intro') ?1:10;
            let _delay1 = $target.eq(0).children().length;
            let _delay2 = $target.eq(1).children().length;

            if(hideTarget !== 'intro'){
                _this.show($('#' + hideTarget).find('.p-kv__text'),'out');
            }
            TweenMax.staggerTo($target.parents('.p-kv__copy').children('.number').children(), 1.4, {
                x: 100,
                z: -1000,
                opacity: 0,
                ease: Power2.easeOut
            },0.2);
            TweenMax.staggerTo($target.eq(0).children(), 1.4, {
                x: _setX1,
                y: -(_this.center.y / _setY),
                z: -2000,
                rotationX: 120,
                force3D: true,
                opacity: 0,
                ease: Power2.easeOut
            },0.04);
            TweenMax.staggerTo($target.eq(1).children(), 1.4, {
                delay:_delay1*0.04,
                x: _setX2,
                y: -(_this.center.y / _setY),
                z: -2000,
                rotationX:120,
                force3D:true,
                opacity:0,
                ease: Power2.easeOut
            },0.04)
            TweenMax.staggerTo($target.eq(2).children(), 1.4, {
                delay:_delay1*0.04 + _delay2*0.04,
                x: _setX3,
                y: -(_this.center.y / _setY),
                z: -2000,
                rotationX:120,
                force3D:true,
                opacity:0,
                ease: Power2.easeOut
            },0.04);
            setTimeout(function(){
                $('#' + hideTarget).removeClass('is-current');
                $('#' + hideTarget).find('.is-done').removeClass('is-done');
            //},(_delay1*1.2 + _delay2*1.2) * 100);
            },(_delay1*1.2 + _delay2*1.2) * 100);
        }else{
            for (let i = 0; i < _length; i++) {
                TweenMax.to($target.eq(i), 1.86,
                    {
                        delay:0.1*i,
                        x:0,
                        y:0,
                        z:0,
                        rotationX:0,
                        force3D:true,
                        ease: Expo.easeOut,
                        onStart:function(){
                            setTimeout(function(){
                                $target.eq(i).addClass('is-done');
                            },900);
                        }
                    },
                );
                TweenMax.to($target.eq(i), 2.2,
                    {
                        delay:0.12*i,
                        opacity:1,
                        ease: Expo.easeOut
                    },
                );
            }
            TweenMax.staggerTo($target.parents('.p-kv__copy').children('.number').children(), 1.4, {
                delay:0.6,
                x: 0,
                z: 0,
                opacity: 1,
                ease: Power2.easeOut
            },0.2);
            if(_showID !== 'intro'){
                _this.show($('#' + _showID).find('.p-kv__text'),'in');
            }else{
                let _elements = $('#p-kv__drag__inner,#p-kv__description>*');
                TweenMax.set(_elements, {
                    x: 0,
                    y: 0,
                    z: 0,
                    rotationX:0,
                    opacity: 1,
                });
                let _element = $('#p-kv__drag,#p-kv__description,#c-scrolldown,.c-social-link');
                _this.show(_element,"set");
                _this.show(_element,"show");
            }
        }

    }

    topAnimation(type,loadType){

        let _this = this;

        const tlSet = new TimelineMax();
        const tlOut = new TimelineMax();

        let _kvCopy = $('#intro .p-kv__copy');
        let _kvBtn = $('#p-kv__drag,#p-kv__description');
        let _content = $('#p-top-content');
        let _visionTitle = $("#p-top-our-vision").find('.p-top-section__title__text');
        let _visionsubTitle = $("#p-top-our-vision").find('.p-top-section__title__sub');
        let _visionLine = $("#p-top-our-vision").find('.p-top-section__title__line');
        let _visionText = $("#p-top-our-vision").find('.p-top-section__sub-title,.p-top-section__text');

        if(type === "set") {

            let _setZ = (loadType === 'landing') ?1500:-1500;

            tlSet.set(_kvCopy.children().children().children(), {
                x:  _this.center.x +  _this.offsetX,
                y: -(_this.center.y),
                z: _setZ,
                rotationX: 170,
                force3D: true,
                opacity: 0
            }).set(_visionTitle.children().children(),{
                y: 50,
                color: '#2bf3d9',
                opacity:0
            })
            .set(_visionsubTitle,{ opacity:0})
            .set(_visionLine,{
                backgroundColor: '#2f3440',
                y:50,
                opacity:0
            })
            .set(_visionText,{
                opacity:0
            })
            .set(_visionText.find('.js__tsc-cover'),{
                    x:'-50%'
            });

        }else if(type === "out"){

            TweenMax.to($("#p-kv__bg"), 2.4,{
                opacity:0,
                ease: Expo.easeOut
            });
            _this.depth(_kvCopy.children().children(),'out','intro');

            let _element = $('#p-kv__drag__inner,#p-kv__description>*');
            TweenMax.to(_element, 1.4, {
                x: 0,
                y: 0,
                z: -2000,
                rotationX: 125,
                force3D: true,
                opacity: 0,
                ease: Power2.easeOut
            });

            tlOut.to(_kvBtn, 0.48, {
                z: -2000,
                rotationX:170,
                force3D:true,
                opacity:0,
                ease: Expo.easeOut,
                onComplete:function(){
                    setTimeout(()=>{
                        // TweenMax.set($("#p-kv"),{
                        //     zIndex:'-1'
                        // })
                        TweenMax.to(_visionLine,1.8, {
                            delay:1.2,
                            opacity: 1,
                            y:0,
                            ease: Power4.easeOut
                        });
                        TweenMax.staggerFromTo(_visionTitle.children().children(),1.8, {
                            y: 10,
                            color: '#2bf3d9',
                            opacity:0,
                        },{
                            delay:1.35,
                            y: 0,
                            opacity:1,
                            ease: Expo.easeOut,
                            onStart:function(){
                                TweenMax.to(_visionLine,1.2, {
                                    delay:0.9,
                                    backgroundColor: '#2bf3d9',
                                    ease: Expo.easeOut
                                });
                                _this.content(_visionText.find('.js__tsc-cover'),"in");
                                _this.lineText($('#p-top-our-vision__big-text'),"show");
                            }
                        },0.05);
                        TweenMax.staggerTo(_visionTitle.children().children(),2.1, {
                            delay:1.6,
                            color: '#2f3440',
                        },0.06);

                        TweenMax.to(_visionsubTitle,2, {
                            delay:1.3,
                            opacity: 1,
                            ease: Expo.easeOut
                        });
                        TweenMax.set(_visionText,{
                            delay:1.3,
                            opacity:1,
                        });
                    },650);
                }
            })
            .to(_content, 1.28, {
                delay:.3,
                //zIndex:1,
                'opacity': 1,
                ease: Power2.easeIn
            });

        }else{

            _kvCopy.children().children().removeAttr('style');
            _this.show(_kvBtn,"set");
            _this.show(_kvBtn,"show");

            let _delay = (loadType === 'landing') ?0:.48;

            TweenMax.to($("#p-kv__bg"), 1.9,{
                delay:_delay,
                opacity:0.1,
                ease: Circ.easeOut
            });

            _this.depth(_kvCopy.children().children().children(),'in');

            setTimeout(function(){
                TweenMax.to($("#l-header"), 2.8,{
                    delay:0.4,
                    y:0,
                    ease: Expo.easeOut
                });
            },3e3);

        }

    }

}
